/**
 * Stripe.js + react-stripe-js bridge — WEB IMPLEMENTATION.
 *
 * Vite's resolver picks this file (`.web.tsx`) before the sibling
 * `webElements.tsx` (which is the native stub).  Vite's
 * `resolve.extensions` lists `.web.tsx` first.
 *
 * The exports are re-exports from @stripe/stripe-js and
 * @stripe/react-stripe-js — both are pure-web npm packages, no
 * native side effects, so top-level static imports are safe under
 * Vite's bundler.
 *
 * NOTE on the `as any` casts: payment-methods.tsx and
 * StripeProvider.tsx were originally written against `let X: any`
 * placeholders (because the code did `require()` inside a
 * Platform.OS check), so every consumer site uses the loose `any`
 * shape — passing `children: ReactNode` to <Elements>, etc.  The
 * real types from @stripe/react-stripe-js are stricter
 * (`ReactElement | ReactElement[]`), which breaks tsc.  Rather than
 * rewrite every call site, we cast at the export boundary.  If you
 * tighten the consumer code later, you can drop the casts.
 */
import {
  Elements as RealElements,
  PaymentElement as RealPaymentElement,
  useStripe as realUseStripe,
  useElements as realUseElements,
} from '@stripe/react-stripe-js';
import { loadStripe as realLoadStripe } from '@stripe/stripe-js';

export const Elements: any = RealElements;
export const PaymentElement: any = RealPaymentElement;
export const useStripe: any = realUseStripe;
export const useElements: any = realUseElements;
export const loadStripe: any = realLoadStripe;
